import { api } from "roboflex-thalamus-request-handler";

/**
 * Famílias de produto (status ativo).
 * @returns {Promise<{ id: number, cod: string|number, nome: string }[]>}
 */
export default {
  async listar() {
    const response = await api.get("familia/listar");
    const raw = response?.data ?? response;
    const list = Array.isArray(raw) ? raw : Array.isArray(raw?.data) ? raw.data : [];
    return list.map((f) => ({
      id: Number(f.id),
      cod: f.cod ?? f.familia_num ?? "",
      nome: f.nome ?? f.familia_nome ?? "",
    }));
  },
};
